import { createSlice } from "@reduxjs/toolkit";

const initalDialogState = {
    isDialogEnabled: false,
    dialogType:'',
    dataObj:{},
    requestId: 0
}



const dialogSlice = createSlice({
    name: 'dialog',
    initialState: initalDialogState,
    reducers:{
        setIsDialogEnabled(state,action) {
            state.isDialogEnabled = action.payload;
        },
        setDialogType (state,action) {
            state.dialogType = action.payload;
        },
        setDataObj(state,action) {
            state.dataObj = action.payload;
        },
        setRequestId(state,action) {
            state.requestId = action.payload;
        }
    }
});

export const dialogActions = dialogSlice.actions;

export default dialogSlice.reducer;